import script from "./AlarmsRepository.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlarmsRepository.vue?vue&type=script&lang=ts&setup=true"

import "./AlarmsRepository.vue?vue&type=style&index=0&id=79fe2f6a&lang=scss"

const __exports__ = script;

export default __exports__